"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var appMargins_1 = __importDefault(require("../../../../../app/components/AppMargins/appMargins"));
var PaginationActionComponent_1 = __importDefault(require("../../../../../app/components/widgets/PaginationActionComponent"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return core_1.createStyles({
        pagination: (_a = {
                zIndex: -1,
                marginTop: theme.spacing(2),
                marginBottom: theme.spacing(6),
                backgroundColor: 'white'
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: theme.spacing(5),
            },
            _a),
        paginationCell: {
            padding: 0,
            border: 'none',
            width: '100%',
        },
        paginationRow: {
            height: 'fit-content',
            border: 'none',
        },
        toolbar: {
            paddingLeft: function (props) {
                return props.appMargins;
            },
            paddingRight: function (props) {
                return props.appMargins;
            },
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
        },
        spacer: {
            flex: 0,
        },
        caption: (_b = {
                fontWeight: 400,
                marginRight: '4px'
            },
            _b[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _b),
        select: (_c = {
                border: 'solid 1px #d8d8d8',
                zIndex: 2
            },
            _c[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _c),
        selectIcon: (_d = {
                zIndex: 2
            },
            _d[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _d),
    });
});
/**
 * @component Holds the drop down option for the result count and page number.
 */
var DirectoryTablePagination = function (_a) {
    var pageCount = _a.pageCount, rowsPerPage = _a.rowsPerPage, resultsCount = _a.resultsCount, currentPage = _a.currentPage, disablePagination = _a.disablePagination, changePageHandler = _a.changePageHandler, changeRowsPerPageHandler = _a.changeRowsPerPageHandler;
    var _b = __read(react_i18next_1.useTranslation(), 1), t = _b[0];
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    return (react_1.default.createElement(core_1.TableRow, { key: "pagination", className: classes.paginationRow },
        react_1.default.createElement(core_1.TableCell, { className: classes.paginationCell },
            react_1.default.createElement(core_1.TablePagination, { className: classes.pagination, ActionsComponent: function (_a) {
                    var onPageChange = _a.onPageChange, page = _a.page;
                    return (react_1.default.createElement(PaginationActionComponent_1.default, { pageCount: pageCount, onChangePage: onPageChange, page: page, disablePagination: disablePagination }));
                }, labelRowsPerPage: t('text.linksPerPage'), rowsPerPageOptions: [10, 25, 100], component: "div", count: resultsCount, rowsPerPage: rowsPerPage, page: currentPage, backIconButtonProps: {
                    'aria-label': 'previous page',
                }, nextIconButtonProps: {
                    'aria-label': 'next page',
                }, onPageChange: changePageHandler, onChangeRowsPerPage: changeRowsPerPageHandler, classes: {
                    spacer: classes.spacer,
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                    select: classes.select,
                    selectIcon: classes.selectIcon,
                } }))));
};
exports.default = DirectoryTablePagination;
